import React from 'react';
import './StripeInputWrapper.less';

export const StripeInputWrapper = ({children}) => {
	return <div className="stripe-input-wrapper">{children}</div>
}
